// eslint-disable-next-line import/prefer-default-export
export const onServiceWorkerUpdateReady = () => window.location.reload();
